export default __webpack_public_path__ + "assets/images/komunikaciona-strategija-lazar-dzamic-homepageacademy-1200x628.jpg";